import { makeStyles } from '@material-ui/core'

export const useDailyGreetingStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem'
  },
  greeting: {
    fontSize: '1.25rem',
    fontWeight: 700,
    color: '#212945',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },
  wave: {
    fontSize: '1.25rem',
    lineHeight: 1
  },
  subtitle: {
    fontSize: '0.875rem',
    color: 'rgba(33, 41, 69, 0.7)',
    lineHeight: 1.5
  },
  countSkeleton: {
    display: 'inline-block',
    width: '1.5rem',
    height: '0.875rem',
    verticalAlign: 'middle',
    backgroundColor: 'rgba(33, 41, 69, 0.12)',
    borderRadius: '4px',
    backgroundImage:
      'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0) 100%)',
    backgroundSize: '200% 100%',
    animation: '$dailyGreetingShimmer 1.5s ease-in-out infinite'
  },
  '@keyframes dailyGreetingShimmer': {
    '0%': { backgroundPosition: '-200% 0' },
    '100%': { backgroundPosition: '200% 0' }
  }
}))
